import { ConfigService } from './config';

export * from './config';

export const configProviders = [ConfigService];
